<template>
  <div class="repurchase-table-wrapper">
    <slot></slot>
    <RkTable
      class="repurchase-table"
      :data="sliceEventList"
      :loading="loading"
      :finished="finished"
      :show-footer="showFooter"
    >
      <template #footer>
        <ShowMoreButton v-if="eventList.length > initLength" v-model="isMore" />
      </template>
      <RkTableColumn prop="changeDate" label="回购日期" fixed align="left" :width="`${postcssPatch(100)}`">
        <template #default="{ row }">{{ $digitjs(row.changeDate).isNull() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="repurchaseNumber" label="数量(股)" :width="`${postcssPatch(90)}`">
        <template #default="{ row }">{{ $digitjs(row.repurchaseNumber).rounded() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="repurchaseMoney" label="金额" :width="`${postcssPatch(90)}`">
        <template #default="{ row }">{{ $digitjs(row.repurchaseMoney).isNull() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="highPrice" label="最高价" :width="`${postcssPatch(90)}`">
        <template #default="{ row }">{{ $digitjs(row.highPrice).convert() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="lowPrice" label="最低价" :width="`${postcssPatch(90)}`">
        <template #default="{ row }">{{ $digitjs(row.lowPrice).convert() }}</template>
      </RkTableColumn>
      <!-- TODO 接口缺失字段 临时隐藏 -->
      <!--      <RkTableColumn prop="&#45;&#45;" label="累计回购数量(股)" :width="`${postcssPatch(160)}`">-->
      <!--        <template #default="{ row }">{{ $digitjs(row.purchasedSinceResolution).convert(0) }}</template>-->
      <!--      </RkTableColumn>-->
      <!--      <RkTableColumn prop="&#45;&#45;" label="累计回购数量占比" :width="`${postcssPatch(160)}`">-->
      <!--        <template #default="{ row }">{{ $digitjs(row.purchasedRateSinceResolution).unit('%').rounded() }}</template>-->
      <!--      </RkTableColumn>-->
    </RkTable>
  </div>
</template>

<script>
import ShowMoreButton from '@/components/common/ShowMoreButton.vue'
import { postcssPatch } from '@/utils/postcssPatch'
export default {
  components: { ShowMoreButton },
  props: {
    showFooter: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number
    },
    initLength: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      loading: false,
      finished: false,
      isMore: false,
      eventList: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    sliceEventList() {
      if (this.total) {
        return this.eventList
      } else {
        return this.isMore ? this.eventList : this.eventList.slice(0, this.initLength)
      }
    }
  },
  created() {
    this.getEventList()
  },
  methods: {
    postcssPatch,
    async getEventList() {
      this.loading = true
      const res = await this.$post(this.$api.f10[this.market] + '/summary/ca-repurchase', {
        startDate: '1990-01-01',
        symbol: this.symbol
      })
      this.eventList = res.data?.slice(0, this.total) ?? []
      this.finished = true
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.repurchase-table-wrapper {
  margin-bottom: var(--section-margin);
  background: var(--bg-color-2);
}

.repurchase-table {
  --table-tbody-font-size: 13px;
}
</style>
